export default "__VITE_ASSET__58ef9c86__"